<template>
	<div v-if="mounted" class="country-autocomplete">
		<div>
			<Dropdown
				v-model="countries"
				:custom-options="options"
				multiple
				@input="emitChangeEvent"
			/>
		</div>
	</div>
</template>

<script>
import _ from "lodash";
import Icon from "@/vue/icon/Icon"
import Dropdown from "@/vue/characteristic/Dropdown.vue";
import {arrayIsNotEmpty} from "@/helper/Array";

export default {

	components: {
		Dropdown,
		Icon,
	},

	props: {
		value: {
			type: Array,
			required: false,
		},
		meta: {
			type: Object,
			required: true,
		},
	},

	mounted ()
	{
		if (this.countries)
		{
			let countries = [];

			_.forEach(this.countries, country =>
			{
				countries.push(
					_.find(this.options, option => option.id === country.id)
				);
			});

			this.countries = countries;
		}

		this.emitChangeEvent();

		this.mounted = true;
	},

	data ()
	{
		return {
			countries: this.value,
			mounted: false,
		};
	},

	computed: {
		options ()
		{
			return _
				.chain(this.meta.country)
				.map(country =>
				{
					return {
						id: country.id,
						label: country.text,
					};
				})
				.value();
		},
	},

	methods: {
		emitChangeEvent ()
		{
			if (arrayIsNotEmpty(this.countries))
			{
				this.$emit('input', this.countries);
				return;
			}

			this.$emit('input', undefined);
		},
	},
}
</script>
